import React, { useState, useRef, useEffect } from "react";
import "./style.scss";
import { Container } from "react-bootstrap";
import { BiLogoFacebook } from "react-icons/bi";
import { RiTwitterXFill } from "react-icons/ri";
import { FaInstagram, FaUser } from "react-icons/fa";
import { AiOutlineYoutube } from "react-icons/ai";
import { MdLogout, MdSettings } from "react-icons/md";
import Logo from "../../asset/images/logo_light.png";
import Timer from "./time";
import { Button, Form, Input, Modal, notification } from "antd";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import { logout, updateProfile } from "../../store/authSlice";
const Header = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector(
    (state: RootState) => state.auth
  );
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);
  const [logoutConfirm, setLogoutConfirm] = useState(false);
  const [profileModal, setProfileModal] = useState(false);
  const [profileLoading, setProfileLoading] = useState(false);
  const [profileForm] = Form.useForm();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const mobileDropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowUserDropdown(false);
      }
      if (
        mobileDropdownRef.current &&
        !mobileDropdownRef.current.contains(event.target as Node)
      ) {
        setShowMobileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handlelogoutConfirm = () => {};

  const handleLogout = () => {
    dispatch(logout());
    setShowUserDropdown(false);
    setShowMobileDropdown(false);
    // Clear any persisted auth data
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
  };

  const openProfileModal = () => {
    profileForm.setFieldsValue({
      full_name: user?.full_name || "",
      email: user?.email || "",
      phone: user?.phone || "",
    });
    setProfileModal(true);
    setShowUserDropdown(false);
    setShowMobileDropdown(false);
  };

  const handleUpdateProfile = async (values: any) => {
    setProfileLoading(true);
    try {
      const payload: any = {};
      if ((values.full_name || "").trim() !== (user?.full_name || "")) {
        payload.full_name = values.full_name.trim();
      }
      if ((values.email || "").trim().toLowerCase() !== (user?.email || "")) {
        payload.email = values.email.trim().toLowerCase();
      }
      if ((values.phone || "").trim() !== (user?.phone || "")) {
        payload.phone = values.phone.trim();
      }

      if (Object.keys(payload).length === 0) {
        notification.info({
          message: "No changes",
          description: "There are no changes to save.",
          placement: "topRight",
        });
        setProfileLoading(false);
        return;
      }

      const result = await (dispatch as any)(updateProfile(payload)).unwrap();

      notification.success({
        message: "Success",
        description: result.message || "Profile updated successfully",
        placement: "topRight",
      });

      setProfileModal(false);
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error || "Failed to update profile",
        placement: "topRight",
      });
    } finally {
      setProfileLoading(false);
    }
  };

  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .substring(0, 2)
      .toUpperCase();
  };

  return (
    <div className="Header">
      <Container>
        <div className="Header-box">
          <div className="Header-box1">
            <Timer onChange={(val: any) => props.onChange(val)} />
          </div>
          <div className="Header-box4">
            <Timer onChange={(val: any) => props.onChange(val)} />
          </div>
          <div className="Header-box2" onClick={() => navigate("/")}>
            <img src={Logo} className="Header-logo" alt="" />
          </div>
          <div className="Header-box3">
            <div className="Header-icon">
              <a
                href="https://www.youtube.com/@Suprabhaatham2023"
                target="_blank"
                rel="noreferrer"
              >
                <AiOutlineYoutube size={20} color="#000" />
              </a>
            </div>
            <div className="Header-icon">
              <a
                href="https://twitter.com/suprabhaatham?lang=en"
                target="_blank"
                rel="noreferrer"
              >
                <RiTwitterXFill size={18} color="#000" />
              </a>
            </div>
            <div className="Header-icon">
              <a
                href="https://www.instagram.com/suprabhaathamonline/?hl=en"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram size={20} color="#000" />
              </a>
            </div>
            <div className="Header-icon">
              <a
                href="https://www.facebook.com/Suprabhaatham/"
                target="_blank"
                rel="noreferrer"
              >
                <BiLogoFacebook size={20} color="#000" />
              </a>
            </div>
            {isAuthenticated && (
              <div className="Header-user-avatar" ref={dropdownRef}>
                <div
                  className="Header-avatar"
                  onClick={() => setShowUserDropdown(!showUserDropdown)}
                >
                  <div className="Header-avatar-circle">
                    {user?.full_name ? getInitials(user.full_name) : <FaUser />}
                  </div>
                </div>
                {showUserDropdown && (
                  <div className="Header-user-dropdown">
                    <div className="Header-user-info">
                      <div className="Header-user-name">{user?.full_name}</div>
                      <div className="Header-user-email">{user?.email}</div>
                    </div>
                    <div className="Header-user-divider"></div>
                    <div className="Header-user-actions">
                      <button
                        className="Header-logout-btn"
                        onClick={openProfileModal}
                      >
                        <FaUser size={14} />
                        Profile
                      </button>
                      <button
                        className="Header-logout-btn"
                        onClick={() => {
                          setShowUserDropdown(false);
                          setShowMobileDropdown(false);
                          navigate("/settings");
                        }}
                      >
                        <MdSettings size={16} />
                        Settings
                      </button>
                      <button
                        className="Header-logout-btn"
                        onClick={() => setLogoutConfirm(true)}
                      >
                        <MdLogout size={16} />
                        Logout
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="Header-box4">
            {isAuthenticated && (
              <div className="Header-mobile-avatar" ref={mobileDropdownRef}>
                <div
                  className="Header-avatar"
                  onClick={() => setShowMobileDropdown(!showMobileDropdown)}
                >
                  <div className="Header-avatar-circle">
                    {user?.full_name ? getInitials(user.full_name) : <FaUser />}
                  </div>
                </div>
                {showMobileDropdown && (
                  <div className="Header-mobile-dropdown">
                    <div className="Header-user-info">
                      <div className="Header-user-name">{user?.full_name}</div>
                      <div className="Header-user-email">{user?.email}</div>
                    </div>
                    <div className="Header-user-divider"></div>
                    <div className="Header-user-actions">
                      <button
                        className="Header-logout-btn"
                        onClick={openProfileModal}
                      >
                        <FaUser size={14} />
                        Profile
                      </button>
                      <button
                        className="Header-logout-btn"
                        onClick={() => {
                          setShowUserDropdown(false);
                          setShowMobileDropdown(false);
                          navigate("/settings");
                        }}
                      >
                        <MdSettings size={16} />
                        Settings
                      </button>
                      <button
                        className="Header-logout-btn"
                        onClick={() => setLogoutConfirm(true)}
                      >
                        <MdLogout size={16} />
                        Logout
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Container>

      {logoutConfirm ? (
        <Modal
          title="Logout"
          // closable={{ "aria-label": "Custom Close Button" }}
          open={logoutConfirm}
          onOk={handleLogout}
          onCancel={() => setLogoutConfirm(false)}
        >
          <p>Are you sure you want to logout?</p>
        </Modal>
      ) : null}

      <Modal
        title="Profile"
        open={profileModal}
        onCancel={() => {
          setProfileModal(false);
          profileForm.resetFields();
        }}
        footer={null}
        width={500}
        destroyOnClose
      >
        <br />
        <Form
          form={profileForm}
          layout="vertical"
          onFinish={handleUpdateProfile}
          autoComplete="off"
        >
          <Form.Item
            label="Full Name"
            name="full_name"
            rules={[
              { required: true, message: "Please enter your name" },
              {
                validator: (_, value) =>
                  value && value.trim().length > 0
                    ? Promise.resolve()
                    : Promise.reject(new Error("Name cannot be empty")),
              },
            ]}
          >
            <Input placeholder="Enter your name" size="large" />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input placeholder="Enter your email" size="large" />
          </Form.Item>

          <Form.Item
            label="Mobile Number"
            name="phone"
            rules={[
              { required: true, message: "Please enter your mobile number" },
              {
                pattern: /^[+0-9\s-]{7,20}$/,
                message: "Please enter a valid mobile number",
              },
            ]}
          >
            <Input placeholder="Enter your mobile number" size="large" />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
            <div
              style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
            >
              <Button
                onClick={() => {
                  setProfileModal(false);
                  profileForm.resetFields();
                }}
                disabled={profileLoading}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={profileLoading}
              >
                Save Changes
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Header;
